var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$emit('handle-show-off')}}},[_c('div',{staticStyle:{"position":"absolute","width":"100%","z-index":"5"}},[(_vm.courseShow)?_c('CourseMaterial',{on:{"handle-show-course":_vm.showCourse}}):_vm._e()],1),_c('div',{staticClass:"mt-lg-6 mt-md-3 mt-0"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }